"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BaseDateInput = exports.defaultDateFormat = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _invariant = _interopRequireDefault(require("invariant"));

var _propTypes2 = _interopRequireDefault(require("@styled-system/prop-types"));

var _utils = require("../../style/utils");

var _events = _interopRequireDefault(require("../../utils/helpers/events/events"));

var _date = _interopRequireDefault(require("../../utils/helpers/date/date"));

var _tags = _interopRequireDefault(require("../../utils/helpers/tags/tags"));

var _datePicker = _interopRequireDefault(require("./date-picker.component"));

var _date2 = _interopRequireDefault(require("./date.style"));

var _textbox = _interopRequireDefault(require("../textbox"));

var _withUniqueIdProps = _interopRequireDefault(require("../../utils/helpers/with-unique-id-props"));

var _browserTypeCheck = require("../../utils/helpers/browser-type-check");

var _i18nContext = _interopRequireDefault(require("../../__internal__/i18n-context"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const defaultDateFormat = "DD/MM/YYYY";
exports.defaultDateFormat = defaultDateFormat;
const hiddenDateFormat = "YYYY-MM-DD";
const marginPropTypes = (0, _utils.filterStyledSystemMarginProps)(_propTypes2.default.space); // Spacing props filtering is a temporary solution until FormField and all related components are refactored
// FIXME FE-3370

const filterOutSpacingProps = obj => Object.fromEntries(Object.entries(obj).filter(([key]) => !_propTypes2.default.space[key]));

let BaseDateInput = /*#__PURE__*/function (_React$Component) {
  _inherits(BaseDateInput, _React$Component);

  var _super = _createSuper(BaseDateInput);

  function BaseDateInput(...args) {
    var _this;

    _classCallCheck(this, BaseDateInput);

    _this = _super.call(this, ...args);

    _defineProperty(_assertThisInitialized(_this), "localeData", {
      locale: _this.context.locale(),
      formats: _this.context.date.formats.inputs(),
      format: _this.context.date.formats.javascript()
    });

    _defineProperty(_assertThisInitialized(_this), "isBlurBlocked", false);

    _defineProperty(_assertThisInitialized(_this), "isOpening", false);

    _defineProperty(_assertThisInitialized(_this), "inputHasFocus", _this.props.autoFocus || false);

    _defineProperty(_assertThisInitialized(_this), "isControlled", _this.props.value !== undefined);

    _defineProperty(_assertThisInitialized(_this), "initialVisibleValue", generateAdjustedValue(_this.props, _this.localeData));

    _defineProperty(_assertThisInitialized(_this), "inputFocusedViaPicker", false);

    _defineProperty(_assertThisInitialized(_this), "hasMounted", false);

    _defineProperty(_assertThisInitialized(_this), "inputPresentationRef", /*#__PURE__*/_react.default.createRef());

    _defineProperty(_assertThisInitialized(_this), "state", {
      isDatePickerOpen: false,

      /** Date object to pass to the DatePicker */
      selectedDate: _date.default.stringToDate(_date.default.formatValue({
        value: _this.initialVisibleValue,
        ..._this.localeData
      })),

      /** Displayed value, format dependent on a region */
      visibleValue: _this.initialVisibleValue,

      /** Stores last valid values to be emitted onBlur if current input is invalid */
      lastValidEventValues: {
        formattedValue: _this.initialVisibleValue,
        rawValue: _date.default.formatValue({
          value: _this.initialVisibleValue,
          ..._this.localeData
        })
      },
      shouldPickerOpen: false
    });

    _defineProperty(_assertThisInitialized(_this), "hasValueChanged", prevProps => {
      if (_this.props.allowEmptyValue) {
        return prevProps.value !== _this.props.value;
      }

      return _this.props.value && prevProps.value !== _this.props.value;
    });

    _defineProperty(_assertThisInitialized(_this), "assignInput", input => {
      _this.input = input.current;
      _this.inputPresentationRef.current = input.current.parentElement;
    });

    _defineProperty(_assertThisInitialized(_this), "shouldAllowBlur", () => {
      return (0, _browserTypeCheck.isEdge)(navigator) && !_this.inputFocusedViaPicker;
    });

    _defineProperty(_assertThisInitialized(_this), "shouldBlockBlur", () => {
      const {
        disabled,
        readOnly
      } = _this.props;
      const block = _this.isBlurBlocked || _this.inputFocusedViaPicker || _this.input === document.activeElement;

      if (disabled || readOnly || block) {
        _this.inputFocusedViaPicker = _this.input === document.activeElement; // needed to block blur properly in Edge

        if (!_this.shouldAllowBlur()) {
          return true;
        }
      }

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", () => {
      // needed to make blur work properly in Edge
      // https://stackoverflow.com/a/24695316/10894881
      setTimeout(() => {
        _this.inputHasFocus = false;

        if (_this.shouldBlockBlur()) {
          return;
        }

        _this.reformatVisibleDate();

        if (_this.props.onBlur && !_this.state.isDatePickerOpen) {
          const dateWithSlashes = _date.default.sanitizeDateInput(_this.state.visibleValue);

          const event = _this.buildCustomEvent({
            target: _this.input,
            type: "blur"
          }, _date.default.formatValue({
            value: dateWithSlashes,
            ..._this.localeData
          }));

          _this.props.onBlur(event);
        }
      }, 0);
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocus", ev => {
      _this.inputHasFocus = true;
      const {
        disabled,
        readOnly
      } = _this.props;
      if (disabled || readOnly) return;

      if (_this.isAutoFocused) {
        _this.isAutoFocused = false;
      } else {
        _this.openDatePicker();
      }

      if (_this.props.onFocus) {
        _this.props.onFocus(ev);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", ev => {
      if (_this.props.onKeyDown) _this.props.onKeyDown(ev);

      if (_events.default.isTabKey(ev)) {
        _this.isOpening = false;
        _this.inputFocusedViaPicker = false;

        _this.closeDatePicker();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "openDatePicker", openedOnMount => {
      document.addEventListener("click", _this.closeDatePicker);

      if (!openedOnMount && _this.inputFocusedViaPicker) {
        _this.isBlurBlocked = true;
        return;
      }

      _this.updateSelectedDate(_this.props.value || _date.default.formatValue({
        value: _this.state.visibleValue,
        ..._this.localeData
      }));

      _this.setState({
        isDatePickerOpen: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "updateValidEventValues", value => {
      if (_this.hasMounted) {
        _this.setState({
          visibleValue: _date.default.formatDateToCurrentLocale({
            value,
            ..._this.localeData
          }),
          lastValidEventValues: {
            formattedValue: _date.default.formatDateToCurrentLocale({
              value,
              ..._this.localeData
            }),
            rawValue: _date.default.formatValue({
              value,
              ..._this.localeData
            })
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "reformatVisibleDate", () => {
      const {
        lastValidEventValues,
        visibleValue
      } = _this.state;

      if (_date.default.isValidDate({
        value: visibleValue,
        ..._this.localeData
      }) || _this.canBeEmptyValues(visibleValue)) {
        _this.updateValidEventValues(visibleValue);
      } else if (!visibleValue.length) {
        _this.updateValidEventValues(lastValidEventValues.formattedValue);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "closeDatePicker", () => {
      if (_this.isOpening) {
        _this.isOpening = false;
        return;
      }

      document.removeEventListener("click", _this.closeDatePicker);

      _this.setState({
        isDatePickerOpen: false,
        shouldPickerOpen: false
      }, () => {
        _this.isBlurBlocked = false;

        if (_this.input !== document.activeElement) {
          _this.handleBlur();
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleIconClick", () => {
      if (_this.props.disabled || _this.props.readOnly) return;
      _this.isOpening = true;

      _this.setState(({
        shouldPickerOpen
      }) => ({
        shouldPickerOpen: !shouldPickerOpen
      }), () => {
        if (_this.state.shouldPickerOpen) {
          _this.isBlurBlocked = true;
          _this.inputFocusedViaPicker = false;

          _this.openDatePicker();
        } else {
          _this.inputFocusedViaPicker = false;
          _this.isOpening = false;

          _this.closeDatePicker();
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleDateSelect", selectedDate => {
      const stringDateIso = _date.default.formatDateString(selectedDate);

      _this.isBlurBlocked = true;
      _this.isOpening = false;

      _this.updateVisibleValue(stringDateIso);
    });

    _defineProperty(_assertThisInitialized(_this), "updateVisibleValue", date => {
      const visibleValue = _date.default.formatDateToCurrentLocale({
        value: date,
        ..._this.localeData
      });

      const newDate = _this.getDateObject(date);

      _this.setState({
        selectedDate: newDate
      }, () => {
        _this.updateValidEventValues(visibleValue);

        const event = {
          target: _this.input
        };
        event.target.value = visibleValue;

        _this.emitOnChangeCallback(event, date);

        _this.focusInput();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "focusInput", () => {
      _this.inputFocusedViaPicker = true;
      _this.isOpening = false;

      _this.closeDatePicker();

      _this.input.focus();

      _this.isBlurBlocked = false;
    });

    _defineProperty(_assertThisInitialized(_this), "handleVisibleInputChange", ev => {
      const {
        disabled,
        readOnly
      } = _this.props;
      const value = ev.target.value.formattedValue || ev.target.value;

      const dateWithSlashes = _date.default.sanitizeDateInput(value);

      const isValidDate = _date.default.isValidDate({
        value: dateWithSlashes,
        ..._this.localeData
      });

      let isoDateString;
      if (disabled || readOnly) return;
      _this.isBlurBlocked = false;

      if (isValidDate || _this.canBeEmptyValues(value)) {
        isoDateString = _date.default.formatValue({
          value: dateWithSlashes,
          ..._this.localeData
        });

        _this.updateSelectedDate(isoDateString);

        _this.emitOnChangeCallback(ev, isoDateString);
      }

      _this.setState({
        visibleValue: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "updateSelectedDate", newValue => {
      let selectedDate;
      let visibleValue;

      if (!newValue.length) {
        selectedDate = newValue;
        visibleValue = newValue;
      } else {
        selectedDate = _this.getDateObject(newValue);
        visibleValue = _date.default.formatDateToCurrentLocale({
          value: newValue,
          ..._this.localeData
        });
      }

      _this.setState({
        selectedDate,
        visibleValue
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getDateObject", newValue => {
      if (!_date.default.isValidDate({
        value: newValue,
        ..._this.localeData
      })) {
        return _date.default.stringToDate(_date.default.todayFormatted());
      }

      return _date.default.stringToDate(_date.default.formatValue({
        value: newValue,
        ..._this.localeData
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "emitOnChangeCallback", (ev, isoFormattedValue) => {
      if (_this.props.onChange) {
        const event = _this.buildCustomEvent(ev, isoFormattedValue);

        _this.props.onChange(event);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "canBeEmptyValues", value => {
      return _this.props.allowEmptyValue && !value.length;
    });

    _defineProperty(_assertThisInitialized(_this), "buildCustomEvent", (ev, isoFormattedValue) => {
      const {
        type
      } = ev;
      const {
        id,
        name,
        value
      } = ev.target;
      const {
        lastValidEventValues
      } = _this.state;

      const validRawValue = _date.default.isValidDate({
        value: isoFormattedValue,
        ..._this.localeData
      });

      const validValues = _this.canBeEmptyValues(value) ? {
        formattedValue: "",
        rawValue: ""
      } : lastValidEventValues;
      ev.target = { ...(name && {
          name
        }),
        ...(id && {
          id
        }),
        value: { ...validValues,
          ...(validRawValue && {
            formattedValue: _date.default.formatDateToCurrentLocale({
              value,
              ..._this.localeData
            })
          }),
          ...(validRawValue && {
            rawValue: isoFormattedValue
          }),
          ...(type === "blur" && {
            formattedValue: value,
            rawValue: value
          })
        }
      };
      return ev;
    });

    _defineProperty(_assertThisInitialized(_this), "renderDatePicker", dateRangeProps => {
      if (!_this.state.isDatePickerOpen) return null;
      let {
        visibleValue
      } = _this.state;

      if (!_date.default.isValidDate({
        value: visibleValue,
        ..._this.localeData
      })) {
        visibleValue = "";
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        onClick: _this.markCurrentDatepicker,
        role: "presentation"
      }, /*#__PURE__*/_react.default.createElement(_datePicker.default, _extends({
        inputElement: _this.inputPresentationRef,
        selectedDate: _this.state.selectedDate,
        handleDateSelect: _this.handleDateSelect,
        inputDate: visibleValue,
        disablePortal: _this.props.disablePortal
      }, dateRangeProps)));
    });

    _defineProperty(_assertThisInitialized(_this), "markCurrentDatepicker", () => {
      if (_this.props.disabled || _this.props.readOnly) return;
      _this.isOpening = true;
      _this.inputFocusedViaPicker = false;
      _this.isBlurBlocked = true;

      _this.openDatePicker();
    });

    _defineProperty(_assertThisInitialized(_this), "hiddenValue", () => {
      if (_date.default.isValidDate({
        value: _this.state.visibleValue,
        ..._this.localeData
      })) {
        return _date.default.formatValue({
          value: _this.state.visibleValue,
          formatTo: hiddenDateFormat,
          ..._this.localeData
        });
      }

      return _this.state.lastValidEventValues.rawValue;
    });

    _defineProperty(_assertThisInitialized(_this), "renderHiddenInput", () => {
      const props = {
        name: _this.props.name,
        type: "hidden",
        "data-element": "hidden-input",
        value: _this.hiddenValue()
      };
      return /*#__PURE__*/_react.default.createElement("input", props);
    });

    return _this;
  }

  _createClass(BaseDateInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.hasMounted = true;

      if (this.props.autoFocus) {
        this.isAutoFocused = true;
        this.openDatePicker(true);
        this.setState({
          shouldPickerOpen: true
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      const message = "Input elements should not switch from uncontrolled to controlled (or vice versa). " + "Decide between using a controlled or uncontrolled input element for the lifetime of the component";
      (0, _invariant.default)(this.isControlled === (this.props.value !== undefined), message);

      if (this.isControlled && !this.inputHasFocus && this.hasValueChanged(prevProps)) {
        this.updateSelectedDate(this.props.value);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.hasMounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      const {
        minDate,
        maxDate,
        labelInline,
        adaptiveLabelBreakpoint,
        disablePortal,
        tooltipPosition,
        ...inputProps
      } = this.props;
      let events = {};
      delete inputProps.defaultValue;
      delete inputProps.value;
      events = {
        onBlur: this.handleBlur,
        onChange: this.handleVisibleInputChange,
        onFocus: this.handleFocus,
        onKeyDown: this.handleKeyDown,
        onClick: this.handleIconClick,
        iconOnClick: this.handleIconClick
      };
      return /*#__PURE__*/_react.default.createElement(_date2.default, _extends({
        role: "presentation",
        size: inputProps.size,
        labelInline: labelInline
      }, (0, _tags.default)("date", this.props), (0, _utils.filterStyledSystemMarginProps)(this.props)), /*#__PURE__*/_react.default.createElement(_textbox.default, _extends({}, filterOutSpacingProps(inputProps), {
        inputIcon: "calendar",
        value: this.state.visibleValue,
        labelInline: labelInline,
        rawValue: _date.default.formatValue({
          value: this.state.visibleValue,
          ...this.localeData
        }),
        inputRef: this.assignInput,
        adaptiveLabelBreakpoint: adaptiveLabelBreakpoint,
        tooltipPosition: tooltipPosition
      }, events)), this.renderHiddenInput(), this.renderDatePicker({
        minDate,
        maxDate
      }));
    }
  }]);

  return BaseDateInput;
}(_react.default.Component);

exports.BaseDateInput = BaseDateInput;

_defineProperty(BaseDateInput, "contextType", _i18nContext.default);

function generateAdjustedValue({
  value,
  defaultValue,
  allowEmptyValue
}, {
  locale,
  formats,
  format
}) {
  if (value !== undefined && canReturnValue(value, allowEmptyValue, locale, formats, format)) {
    return _date.default.formatDateToCurrentLocale({
      value,
      locale,
      formats,
      format
    });
  }

  if (canReturnValue(defaultValue, allowEmptyValue, locale, formats, format)) {
    return _date.default.formatDateToCurrentLocale({
      value: defaultValue,
      locale,
      formats,
      format
    });
  }

  return _date.default.formatDateToCurrentLocale({
    value: _date.default.todayFormatted(),
    locale,
    formats,
    format
  });
}

function isValidInitialFormat(value, locale, formats, format) {
  return _date.default.isValidDate({
    value,
    options: {
      defaultValue: hiddenDateFormat
    },
    locale,
    formats,
    format
  });
}

function canReturnValue(value, allowEmptyValue, locale, formats, format) {
  if (!allowEmptyValue && value && value.length) {
    const message = "The Date component must be initialised with a value in the iso (YYYY-MM-DD) format";
    (0, _invariant.default)(isValidInitialFormat(value, locale, formats, format), message);
  }

  return isValidInitialFormat(value, locale, formats, format) || allowEmptyValue && !value;
}

const DateInput = (0, _withUniqueIdProps.default)(BaseDateInput);
BaseDateInput.propTypes = { ..._textbox.default.propTypes,
  ...marginPropTypes,

  /** Boolean to allow the input to have an empty value */
  allowEmptyValue: _propTypes.default.bool,

  /** Automatically focus on component mount */
  autoFocus: _propTypes.default.bool,

  /** Boolean to toggle where DatePicker is rendered in relation to the Date Input */
  disablePortal: _propTypes.default.bool,

  /** Minimum possible date YYYY-MM-DD */
  minDate: _propTypes.default.string,

  /** Maximum possible date YYYY-MM-DD */
  maxDate: _propTypes.default.string,

  /** Specify a callback triggered on blur */
  onBlur: _propTypes.default.func,

  /** Specify a callback triggered on change */
  onChange: _propTypes.default.func,

  /** Specify a callback triggered on focus */
  onFocus: _propTypes.default.func,

  /** Name of the input */
  name: _propTypes.default.string,

  /** The current date YYYY-MM-DD */
  value: _propTypes.default.string,

  /** Breakpoint for adaptive label (inline labels change to top aligned). Enables the adaptive behaviour when set */
  adaptiveLabelBreakpoint: _propTypes.default.number,

  /** Flag to configure component as mandatory */
  required: _propTypes.default.bool
};
BaseDateInput.defaultProps = {
  disablePortal: false
};
var _default = DateInput;
exports.default = _default;